import { RemoteData } from '@passionware/monads';
import { ensureError } from '@passionware/platform-js';
import type { BookingType } from '../../../../__types__';
import store from '../../../../store';
import {
  createBookingType,
  updateBookingType
} from '../../../../store/v1/booking_types/booking_types.actions';
import { BookingTypeService } from './BookingTypeService';
import { WithErrorService } from '../../front/ErrorService/ErrorService';
import { WithServices } from '../../../platform/ts/services';

export function createBookingTypeService(
  config: WithServices<[WithErrorService]> & {
    useBookingTypes: () => RemoteData<BookingType[]>;
  }
): BookingTypeService {
  const { errorService } = config.services;
  const interceptor = errorService.withCategory('BookingTypeService');

  return {
    useBookingTypes: config.useBookingTypes,
    createBookingType: interceptor.wrap(async payload => {
      const result = await store.dispatch(createBookingType(payload));
      if (result.error) {
        throw ensureError(result.error);
      }
      return result.result;
    }),
    updateBookingType: interceptor.wrap(async (id, payload) => {
      const result = await store.dispatch(updateBookingType(id, payload));
      if (result.error) {
        throw ensureError(result.error);
      }
      return result.result;
    })
  };
}
